import { render, staticRenderFns } from "./newlistDownUpTwo.vue?vue&type=template&id=28aa0b0e&scoped=true&"
import script from "./newlistDownUpTwo.vue?vue&type=script&lang=js&"
export * from "./newlistDownUpTwo.vue?vue&type=script&lang=js&"
import style0 from "./newlistDownUpTwo.vue?vue&type=style&index=0&id=28aa0b0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28aa0b0e",
  null
  
)

export default component.exports